'use client';

import { useEffect } from 'react';
import { withBase } from '@/lib/base-path';

export default function HomePage() {
  useEffect(() => {
    try {
      const raw = localStorage.getItem('next-robot-ee-auth');
      if (raw) {
        const data = JSON.parse(raw);
        if (data.state?.isAuthenticated) {
          window.location.href = withBase('/dashboard');
          return;
        }
      }
    } catch (err) {
      console.warn('[Auth] повреждённый auth-state в localStorage → на логин:', (err as Error).message);
    }
    window.location.href = withBase('/login');
  }, []);

  return (
    <div className="h-[100dvh] flex items-center justify-center gradient-mesh">
      <div className="animate-pulse-soft text-neutral-400 text-sm">Загрузка...</div>
    </div>
  );
}
